module.exports = __webpack_public_path__ + "static/img/pic1.da2c8f02.png";